import { createSelector } from 'reselect';
import { TRANSPORTER_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectTransporterDomain = state => state[TRANSPORTER_DOMAIN] || initialState;

export const selectTransporters = () => createSelector(selectTransporterDomain, d => d.transporters);

export const selectTransporter = id => createSelector(selectTransporterDomain, d => d.transportersById[id]);

export const selectTransporterCount = () => createSelector(selectTransporterDomain, d => d.transporterCount);
export const selectTransporterPaginator = () => createSelector(selectTransporterDomain, d => d.paginator);

export const selectNewTransporterValue = name => createSelector(selectTransporterDomain, d => d.newTransporter[name]);
export const selectNewTransporter = () => createSelector(selectTransporterDomain, d => d.newTransporter);

export const selectTransporterFilter = () => createSelector(selectTransporterDomain, d => d.filter);

export const selectFilterSingleValue = name =>
  createSelector(selectTransporterFilter, d => d?.properties?.find(f => f.key === name)?.value?.[0] ?? null);
export const selectFilterValues = name =>
  createSelector(selectTransporterFilter, d => d?.properties?.find(f => f.key === name)?.value ?? []);
